<template>
    <div name="search-header" class="wrapper">
        <img src="../../../assets/arrow_back.png" class="back-icn" @click="onClose" />
        <img src="../../../assets/search.png" class="search-icn" />
        <div class="close-icon" @click="closeSearch" v-if="isSearch">
            <img src="../../../assets/search_cancel.png" width="19px"  />
        </div>
        <input class="input-big" 
            style="padding-left: 37px;"
            v-focus-background
            @input="onInput" 
            v-model="keyword"
            ref="searchInput"
            @focus="onFocus"
            placeholder="제품명, 카테고리명 등 입력"
        />
    </div>
</template>

<script>
// search header
// back, search input 
// f: search, back 
import focusBackground from '@/components/directives/focusBackground';
import { debounce } from 'lodash';

export default {
    name: 'searchHeader',
    props: ['isSearch', 'searchRecentKeyword'],
    directives: {
        focusBackground
    },
    mounted: function()
    {
        // this.$refs.searchInput.focus()
    },
    data: function()
    {
        return {
            keyword: ''
        }
    },
    methods: {
        onFocus: function()
        {

        },
        closeSearch: function()
        {
            this.keyword = '';
            this.$emit('closeSearch')
        },
        onClose: function()
        {
            this.$emit('onClose')
        },
        onSearch: function()
        {
            this.$emit('onSearch', this.keyword);
        },
        onInput: debounce(function (event) {
            this.$emit('onSearch', event.target.value);
            // this.fetchSearchResults(event.target.value);
        }, 500),
    },
    watch: {
        searchRecentKeyword: function()
        {
            this.keyword = this.searchRecentKeyword;
            this.$emit('onSearch', this.keyword);
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        padding: 0 16px;
        box-sizing: border-box;
    }
    .input-big {
        width: calc(100% - 29px);
        height: 48px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        padding-left: 16px;
        padding-right: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        box-sizing: border-box;
    }
    input::placeholder {
        color: var(--Gray-50, #A3AAB6);
    }
    .back-icn {
        width: 22px;
        cursor: pointer;
    }
    .search-icn {
        width: 22px;
        position: absolute;
        left: 52px;
        cursor: pointer;
    }
    .close-icon {
        width: 40px;
        height: 40px;
        position: absolute;
        right: 16px;
        z-index: 1;
        top: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/calculator/SearchHeader.vue